import React from 'react';
import { Theme } from '@app/theme';
import { createUseStyles, useTheme } from 'react-jss';
import moment from 'moment-timezone';
import classnames from 'classnames';
import { DayHeaderContentArg } from '@fullcalendar/core';

const useStyles = createUseStyles((theme: Theme) => ({
  headerContainer: {
    backgroundColor: theme.colors.white,
    ...theme.fonts.caption,
    textTransform: 'uppercase',
    textAlign: 'center',
    padding: theme.marginBase / 2,
    paddingBottom: theme.marginBase,
  },
  weekDay: {
    color: theme.colors.inkTertiary,
  },
  date: {
    ...theme.fonts.label,
  },
  today: {
    color: theme.colors.blueAccessible,
  },
}));

interface Props {
  info: DayHeaderContentArg;
}

export const DayHeader = ({ info }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div className={classes.headerContainer}>
      <p
        className={classnames(classes.weekDay, {
          [classes.today]: !!info.isToday,
        })}
      >
        {moment(info.date).format('ddd')}
      </p>
      <p
        className={classnames(classes.date, {
          [classes.today]: !!info.isToday,
        })}
      >
        {moment(info.date).format('DD/MM')}
      </p>
    </div>
  );
};
